import { render, staticRenderFns } from "./PopupBanner.vue?vue&type=template&id=fdc2ca88&scoped=true"
import script from "./PopupBanner.vue?vue&type=script&lang=js"
export * from "./PopupBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc2ca88",
  null
  
)

export default component.exports